<template>
  <div class="footprint-page" v-if="isSmallScreen===false">
  <headers :imageSrc="imageSrc"/>
  <mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
  <bottom/>
  </div>
  <div class="footprint-page" v-else>
  <headers :imageSrc="imageSrc"/>
  <footprint-main :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
  <footprint-foot/>
  </div>
</template>
<script>
import headers from '../../components/headers.vue'
import Mains from '../../components/mains.vue'
import bottom from '../../components/bottom.vue'
import FootprintMain from '../../components/footprintMain.vue'
import FootprintFoot from '../../components/footprintFoot.vue'
export default {
  components: { headers, bottom, Mains, FootprintMain, FootprintFoot },
  data () {
    return {
      isSmallScreen: false,
      imageSrc: '../assets/image/tlf_qyltdn_tzjb.png',
      res1: '碳立方-企业零碳大脑-碳足迹版',
      res2: '建立产品碳足迹核算的数据库系统以及碳足迹的数字孪生分析应用平台，生成产品碳足迹标签，实现了产品生产使用全流程碳排放负荷的多维调控。',
      res3: '',
      res4: '一：某药集团产品碳足迹项目  /  二：某世界五百强食品集团产品碳足迹项目',
      res5: '../assets/2023logoImage/tlf_qyltdn_tzjb.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.res5 = '../assets/footprint/tlf_qyltdn_tzjb.png'
      this.imageSrc = '../assets/image/tlf_qyltdn_tzjbbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.res5 = '../assets/footprint/tlf_qyltdn_tzjb.png'
      this.imageSrc = '../assets/image/tlf_qyltdn_tzjbbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>

<style scoped>

</style>
